import axios from "axios";

// Always use current origin - works in both preview and production
const BACKEND_URL = window.location.origin;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

export const getStats = () => api.get("/stats").then(r => r.data);

export const getBookings = (params) => api.get("/bookings", { params }).then(r => r.data);

export const getBooking = (id) => api.get(`/bookings/${id}`).then(r => r.data);

export const triggerSync = (mode = "full") => api.post(`/sync/trigger?mode=${mode}`).then(r => r.data);

export const getSyncStatus = () => api.get("/sync/status").then(r => r.data);

export const getLogs = (params) => api.get("/logs", { params }).then(r => r.data);

export const getWebhookStatus = () => api.get("/webhook/status").then(r => r.data);

export const getWebhookUrl = () => api.get("/webhook/url").then(r => r.data);

export default api;
